import SimpleModal from 'components/global/SimpleModal';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { handleSubmitDeleteTeam } from 'components/views/InvestorTeam/_helpers/investorTeam.events';
import { $form, $view } from 'signals/global.signals';

const InvestorTeamDeleteModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'delete-team'}
    onHide={handleHideModal}
    title="Delete Team"
    onPrimaryClick={handleSubmitDeleteTeam}
    primaryButtonText="Delete"
    isLoading={$view.value.isModalLoading}
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <p>
      Are you sure you want to delete <b>&quot;{$form.value.name}&quot;</b>?
    </p>
  </SimpleModal>
);

export default InvestorTeamDeleteModal;
